import axios from "../axios";
const endPoint = `/main_category`

export const getcategories = async () => {
    try {
        return await axios.get(`${endPoint}/User_get_mainCategory`)
    } catch (error) {
        console.error("getcategories failed:", error?.message || error)
        // Return a safe fallback shape to avoid runtime crashes
        return { data: { response: [] } }
    }
}